import SnackbarContent from '@mui/material/SnackbarContent'
import { styled } from '@mui/material/styles'

export type Variant = 'error' | 'warning' | 'success' | 'info'

export const StyledSnackbarContent = styled(SnackbarContent)<{ type: Variant }>(
  ({ theme, type }) => {
    const colors: Record<Variant, { color: string; bgColor: string }> = {
      error: {
        color: theme.palette.text.error,
        bgColor: theme.palette.background.error,
      },
      warning: {
        color: theme.palette.text.warning,
        bgColor: theme.palette.background.warning,
      },
      success: {
        color: theme.palette.text.success,
        bgColor: theme.palette.background.success,
      },
      info: {
        color: theme.palette.text.info,
        bgColor: theme.palette.background.info,
      },
    }

    return {
      '&.MuiSnackbarContent-root': {
        padding: 0,
        minHeight: 48,
        display: 'flex',
        alignItems: 'center',
        borderRadius: 8,
        overflow: 'hidden',
        boxShadow: theme.elevation.floating,
        border: `1px solid ${colors[type].color}`,
        backgroundColor: colors[type].bgColor,
      },

      '.MuiSnackbarContent-message': {
        width: '100%',
        height: '100%',
        padding: `${theme.spacing(1)} 13px ${theme.spacing(1)} ${theme.spacing(2)}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        color: theme.palette.text.primary,

        '& > .MuiTypography-root': {
          padding: `0 ${theme.spacing(2)}`,
          flex: 1,
        },

        '> .MuiSvgIcon-root': {
          color: colors[type].color,
        },
      },
    }
  },
)
